import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { salesDataDomainStore } from '../../store';
import { onItemProfileLoadSuccess } from './utils/utils/on-item-profile-load-success';
export const loadItemProfileForSite = async (siteId, reloadCachedData = false) => {
    const state = createOrGetFetchedState(salesDataDomainStore.data.itemProfilesBySiteId, siteId);
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.sales.masterData.itemProfiles.getForSite(siteId),
        state,
        cacheDuration: getCacheDuration('items'),
        reloadCachedData,
        onSuccess: onItemProfileLoadSuccess
    });
};
